import React, { useContext, useCallback } from 'react';
import { Select, RimlessSelect } from '@byte-design/ui';
import { DownOne } from '@icon-park/react';
import { ReactComponent as Logo } from '@/assets/footer-logo.svg';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { globalInfoStoreContext } from '@/models/global';
import { changeLng } from '@/utils/starling';
import { langMap } from '@/const';

export default function Footer() {
  const { t } = useTranslation();
  const globalStore = useContext(globalInfoStoreContext);
  const { lng: language } = globalStore;
  const changeLanguage = useCallback((lang) => {
    globalStore.lng = lang;
    changeLng(lang);
    window.localStorage.setItem('_lang_', lang);
  }, []);
  return (
    <footer className={styles.footer}>
      <div className={styles.info}>
        <div className={styles.logo}>
          <Logo width={100} height={36} />
          <div className={styles.logoText}>
            {t('open_manage_platform')}
          </div>
        </div>
        <div className={styles.links}>
          <div className={styles.linkItem}>
            <div className={styles.linkName}>
              {t('platform_nav')}
            </div>
            <a className={styles.link} href={`${window.location.origin}/gateway/api_manager`} target="_blank" rel="noreferrer">{t('interface_manager')}</a>
            <a className={styles.link} href={`${window.location.origin}/gateway/document/`} target="_blank" rel="noreferrer">{t('open_api_manage')}</a>
            <a className={styles.link} href={`${window.location.origin}/gateway/admin/`} target="_blank" rel="noreferrer">{t('audit_manager')}</a>
          </div>
          <div className={styles.linkItem}>
            <div className={styles.linkName}>
              {t('platform_cooperation')}
            </div>
          </div>
          <div className={styles.linkItem}>
            <div className={styles.linkName}>
              {t('language')}
              <div className={styles.lang}>
                <RimlessSelect
                  onValueChange={changeLanguage}
                  size="xs"
                  width="80px"
                  popoverWidth={100}
                  renderTrigger={() => (
                    <div className={styles.langBox}>
                      <span style={{ width: '60px', cursor: 'pointer' }}>{(langMap as any)[language]}</span>
                      <DownOne
                        size="16"
                        color="#fff"
                        theme="filled"
                        style={{ margin: '0 4px', cursor: 'pointer' }}
                      />
                    </div>
                  )}
                >
                  <Select.Option key={1} value="zh" label="中文" />
                  <Select.Option key={2} value="en" label="English" />
                  <Select.Option key={3} value="ja" label="日本語" />
                </RimlessSelect>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.version}>
        {t('website_record')}
      </div>
    </footer>
  );
}
